// import SupportArticle from './supportArticle/supportArticle';
import MyOpenCard from './myOpenCard/myOpenCard';
import OutageCard from './outageCard/outageCard';
import PCCard from './pcCard/pcCard';
import DeviceCard from './deviceCard/deviceCard';
import EyeBrow from '../commonComponents/eyeBrow/eyeBrow.tsx';
import AcknowledgeCard from './acknowledgeCard/acknowledgeCard';
// import SmallCard from './smallCard/smallCard';
// import CatalogCard from './catalogCard/catalogCard';
import BannerCard from './supportBannerCard';
import ProductCard from './ProductCard';
import QuickLinkCard from './quickLinksCard';
import IcAppCard from './icAppCard/icAppCard';
import GlobalSearchCard from './GlobalSearchCard';
import KnowledgeCard from './knowledgeCard';
import ManageCard from './manageCard';
import DigitalAssistantCard from './digitalAssistantCard/digitalAssistantCard';
import IcServiceRequestCard from './IcServiceRequestCard/IcServiceRequestCard';
import MajorOutageCard from './majorOutageCard/majorOutageCard';

const UptimeCard = {
  // SupportArticle,
  MyOpenCard,
  OutageCard,
  PCCard,
  DeviceCard,
  EyeBrow,
  AcknowledgeCard,
  // SmallCard,
  // CatalogCard,
  BannerCard,
  ProductCard,
  QuickLinkCard,
  IcAppCard,
  GlobalSearchCard,
  KnowledgeCard,
  ManageCard,
  DigitalAssistantCard,
  IcServiceRequestCard,
  MajorOutageCard,
};

export default UptimeCard;
